module.exports = __webpack_public_path__ + "img/Inflammation-SCC_GSE144240.434e4e87.png";